/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
  resize: both;
}

slot {
  display: none;
}

.qds-textarea {
  background-color: var(--qds-theme-control-input-background);
  border-radius: var(--qds-control-border-radius);
  border: var(--qds-control-border-width) solid var(--qds-theme-control-border);
  box-sizing: border-box;
  color: var(--qds-theme-control-text-standard);
  height: 100%;
  padding-inline: var(--qds-control-input-padding-horizontal);
  resize: inherit;
  width: 100%;

  &:disabled {
    opacity: var(--qds-theme-disabled);
    pointer-events: none;
  }

  &:focus-visible {
    outline: var(--qds-control-input-focus-border-width) solid
      var(--qds-theme-control-input-focus-border);
  }

  &:placeholder-shown {
    color: var(--qds-theme-control-text-placeholder);
  }

  &:not(:focus):user-invalid {
    border-color: var(--qds-theme-feedback-result-failure);
  }
}

[data-size='small'] {
  font: var(--qds-control-small-text);
  padding-block: var(--qds-control-small-padding-auto-height);
}

[data-size='standard'] {
  font: var(--qds-control-standard-text);
  padding-block: var(--qds-control-standard-padding-auto-height);
}

[data-size='large'] {
  font: var(--qds-control-large-text);
  padding-block: var(--qds-control-large-padding-auto-height);
}
